import { Grid, Slider, Typography } from '@mui/material';
import React, { useState } from 'react';

import { StyledGridContainer } from '../theme/CustomComponents';
import LearnMore from './LearnMore';

const TemperatureSelector = ({
  onTemperatureChange,
  currentTempValue,
  disabled = false,
  titleBolded = false,
}: {
  onTemperatureChange: (newValue: number) => void;
  currentTempValue?: number;
  disabled?: boolean;
  titleBolded?: boolean;
}): JSX.Element => {
  const [tempPogress, setTempPogress] = useState(currentTempValue || 0.5);

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px' }}>
        <Typography
          variant="body1"
          sx={{
            color: '#070154',
            fontWeight: titleBolded ? 'bold' : 'normal',
          }}
          id={'profile-settings-temp-label'}
        >
          Temperature
        </Typography>
        <LearnMore link="https://howto.westmonroe.com/a/1930840-understanding-and-adjusting-ai-temperature" />
      </div>

      <StyledGridContainer sx={{ mt: '20px' }} container={true}>
        <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center' }}>
          🤖
        </Grid>
        <Grid item xs={10}>
          <Slider
            aria-labelledby={'profile-settings-temp-label'}
            min={0}
            max={1}
            step={0.1}
            marks
            disabled={disabled}
            valueLabelDisplay="auto"
            value={tempPogress}
            onChange={(_, newValue) => {
              setTempPogress(+newValue);
              onTemperatureChange(+newValue);
            }}
            sx={{ color: '#0047FF' }}
          />
        </Grid>
        <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center' }}>
          🍄
        </Grid>
      </StyledGridContainer>
    </>
  );
};

export default TemperatureSelector;
